import { render, staticRenderFns } from "./AboutUsSlide.vue?vue&type=template&id=2783d6cf&scoped=true"
import script from "./AboutUsSlide.vue?vue&type=script&lang=js"
export * from "./AboutUsSlide.vue?vue&type=script&lang=js"
import style0 from "./AboutUsSlide.vue?vue&type=style&index=0&id=2783d6cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2783d6cf",
  null
  
)

export default component.exports